const { default: CTAButton } = require("../../atoms/CTAButton/CTAButton")
const { CustomContainer } = require("../../atoms/DependencyHelper")
import Checkbox from "../../atoms/checkBox/Checkbox";
import UpgradeDropdown from "../../atoms/upgradeDropdown/UpgradeDropdown";
import styles from "./NumberCheckComponent.module.scss";
const NumberCheckComponent = ({ selectedNumber, numberList, handleNumberSelect, buttonDisabled, buttonHandler, buttonStyle, buttonText, checkValue, checkBoxText, checkBoxHandler, showCheckBox }) => {
    return (
        <CustomContainer className={styles["container"]}>
            <UpgradeDropdown
                containerclass={styles["dropdown-container"]}
                selectedValue={selectedNumber}
                optionsList={numberList}
                handleSelect={handleNumberSelect}
                selectClass={"mt-0"}
            />
            {showCheckBox && <CustomContainer className={styles.checkboxContainer}>
                <Checkbox
                    isChecked={!!checkValue}
                    id="checkbox1"
                    click={checkBoxHandler}
                />
                <p className={styles["checkboxText"]}>
                    {checkBoxText}
                </p>
            </CustomContainer>}
            <CustomContainer className={styles["buttonContainer"]}>
                <CTAButton
                    variant={buttonStyle}
                    className={`${styles["continueBtn"]}`}
                    handleClick={() => { buttonHandler(buttonText) }}
                    disabled={buttonDisabled}
                >
                    {buttonText}
                </CTAButton>
            </CustomContainer>
        </CustomContainer>
    )
}

export default NumberCheckComponent;